<template>
    <div class="section-container uk-container uk-container-large">  
        <Rotator 
            path="test"
            :data="filterJson"
            @getCurrentSlide="itemActive = $event.active"
            style="margin: 0;"
        >
           <div class="rotator-text-content">
                <h2 class="h2-small">Похоже, вы перешли на страницу, которая не существует</h2>
                <!--<div class="rotator-text-description" ref="rotator">
                    <span :ref="setItemRef">
                       Интересный факт. Дизельный двигатель потребляет больше воздуха, чем атмосферный. 
                       Если сравнить оба мотора со среднестатистической мощностью в 100 л.с., то у бензинового двигателя за минуту воздушный фильтр пропускает от 6 до 8 кубических метров воздуха, а дизельный потребляет до 40 кубометров
                    </span>
                    <span :ref="setItemRef">
                       Интересный факт. Главным фильтрующим элементом, является специальная бумага, которая помещена в ограниченное пространство в виде «гармошки». 
                       Это делается для того, чтобы увеличить площадь фильтрующей поверхности, чтобы задерживать больше инородных частиц даже самых малых размеров, которые невозможно увидеть невооружённым глазом.
                    </span>
                </div>-->
            </div>
            <div class="rotator-text-button">
                <button class="button button-primary" @click="callModal('marketplace')">Купить на маркетплейс</button>
                <a class="link link-primary" href="/catalog/oil">
                    <span>Подробнее</span> 
                    <IconArrow viewBox="0 0 26 8" />
                </a>
            </div>
        </Rotator>
    </div>           
</template>

<script>
import Rotator from '@/components/rotator/Rotator';
//import filterJson from '@/assets/data/filter-test.json';
//import mixinSection from '@/components/rotator-section/index.js';
import IconArrow from '@/assets/img/svg/arrow.svg?inline';

export default {
    //mixins: [mixinSection], 
    components: {
        Rotator,
        IconArrow
    },
    data() {
       return {
            itemActive: -1,
            filterJson: [],
       }
    },
    methods: {
        callModal(prop) {
            this.$store.commit('modal/CALL_MODAL', prop)
        },
    },
}
</script>